import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './BadgeNotificationBanner.css';
import { badgesAPI } from './services/api';

function BadgeNotificationBanner({ currentUser }) {
  const { t } = useTranslation();
  const [unreactedCount, setUnreactedCount] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      setUnreactedCount(0);
      return;
    }

    const loadUnreactedCount = async () => {
      try {
        const count = await badgesAPI.getUnreactedCount(currentUser.id);
        setUnreactedCount(count);
      } catch (error) {
        console.error('Error loading unreacted badges count:', error);
      }
    };

    loadUnreactedCount();

    // Refresh count every 30 seconds
    const interval = setInterval(loadUnreactedCount, 300000);

    return () => clearInterval(interval);
  }, [currentUser]);

  const handleClick = () => {
    setDismissed(true);
    navigate('/profile', { state: { activeTab: 'received' } });
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setDismissed(true);
  };

  if (!currentUser || unreactedCount === 0 || dismissed) {
    return null;
  }

  return (
    <div className="badge-notification-banner" onClick={handleClick}>
      <span className="notification-icon">⭐</span>
      <span className="notification-text">
        {t('badgeNotificationBanner.text', { count: unreactedCount })}
      </span>
      <span className="notification-arrow">→</span>
      <button className="banner-close-btn" onClick={handleDismiss}>×</button>
    </div>
  );
}

export default BadgeNotificationBanner;
